window.__throttleStore = [];

const hashCode = function (s) {
    return s.split("").reduce(function (a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
};

export function clearThrottledCallStore() {
    window.__throttleStore = [];
}

export function throttledCall(fn, delay) {
    const id = hashCode(fn.toString());

    if (window.__throttleStore[id]) {
        clearTimeout(window.__throttleStore[id]);
    }
    
    window.__throttleStore[id] = setTimeout(() => {
        fn();
        delete window.__throttleStore[id];
    }, delay);
}